import React from "react";
import styled from "styled-components";
import { colors } from "../../theme/color";
import { ButtonProps } from "@mui/material";

interface CustomButtonProps extends React.PropsWithChildren {
  title?: string | React.ReactNode;
  $outline?: boolean;
  $secondary?: boolean;
  $gray?: boolean;
  id?: string;
}
export const CustomButton: React.FC<CustomButtonProps & ButtonProps> = ({
  children,
  title,
  ...props
}) => {
  return <ButtonComponent {...props}>{children || title}</ButtonComponent>;
};

const ButtonComponent = styled.button<{
  $outline?: boolean;
  $secondary?: boolean;
  disabled?: boolean;
  $gray?: boolean;
}>`
  height: 44px;
  border: ${({ $outline, disabled, $gray, $secondary }) =>
    $outline
      ? `
   1px solid ${
     disabled || $gray
       ? colors.NEUTRAL_GREY
       : $secondary
         ? colors.secondary.islamicGreen
         : colors.NAVYBLUE
   }
  `
      : "none"};
  background: ${({ $outline, $secondary, disabled }) =>
    !$outline && !$secondary
      ? colors.NAVYBLUE
      : $secondary && !$outline
        ? colors.secondary.islamicGreen
        : "transparent"};
  color: ${({ $outline, $gray, disabled, $secondary }) =>
    (disabled && !$outline && !$secondary) || $gray
      ? colors.NEUTRAL_GREY
      : $outline && $secondary
        ? colors.secondary.islamicGreen
        : !$outline
          ? "white"
          : colors.NAVYBLUE};
  padding: 0 20px;
  border-radius: 10px;
  font-weight: ${({ $gray }) => ($gray ? "600" : "400")};
  &:hover {
    filter: brightness(90%);
  }
  opacity: ${({ disabled }) => (disabled ? 0.3 : 1)};
  cursor: ${({ disabled }) => (disabled ? "not-allowed" : "pointer")};
`;
